import dayjs, { Dayjs } from "dayjs";

export type PeriodPreset = {
	key: string;
	label: string;
	getRange: () => [Dayjs, Dayjs];
};

export const PERIOD_PRESETS: PeriodPreset[] = [
	{
		key: "today",
		label: "Hoje",
		getRange: () => [dayjs().startOf("day"), dayjs().endOf("day")],
	},
	{
		key: "yesterday",
		label: "Ontem",
		getRange: () => [
			dayjs().subtract(1, "day").startOf("day"),
			dayjs().subtract(1, "day").endOf("day"),
		],
	},
	{
		key: "7d",
		label: "Últimos 7 dias",
		getRange: () => [
			dayjs().subtract(6, "day").startOf("day"),
			dayjs().endOf("day"),
		],
	},
	{
		key: "30d",
		label: "Últimos 30 dias",
		getRange: () => [
			dayjs().subtract(29, "day").startOf("day"),
			dayjs().endOf("day"),
		],
	},
	{
		key: "3m",
		label: "Últimos 3 meses",
		getRange: () => [
			dayjs().subtract(3, "month").add(1, "day").startOf("day"),
			dayjs().endOf("day"),
		],
	},
	{
		key: "6m",
		label: "Últimos 6 meses",
		getRange: () => [
			dayjs().subtract(6, "month").add(1, "day").startOf("day"),
			dayjs().endOf("day"),
		],
	},
];

export const DEFAULT_PERIOD_PRESET = PERIOD_PRESETS.find(
	(preset) => preset.key === "30d",
)!;

const DATE_PARAM_FORMAT = "YYYY-MM-DD";

export function getPeriodRange(searchParams: URLSearchParams): [Dayjs, Dayjs] {
	const fromParam = searchParams.get("from");
	const toParam = searchParams.get("to");

	if (fromParam && toParam) {
		return [dayjs(fromParam).startOf("day"), dayjs(toParam).endOf("day")];
	}

	return DEFAULT_PERIOD_PRESET.getRange();
}

export function findMatchingPreset(
	from: Dayjs,
	to: Dayjs,
): PeriodPreset | undefined {
	return PERIOD_PRESETS.find((preset) => {
		const [presetFrom, presetTo] = preset.getRange();
		return presetFrom.isSame(from, "day") && presetTo.isSame(to, "day");
	});
}

export function formatPeriodParam(date: Dayjs): string {
	return date.format(DATE_PARAM_FORMAT);
}
